/**
 * Utility functions for formatting data across the application
 */

/**
 * Format difficulty value for display
 * Normalizes 'difficult' to 'Hard' and capitalizes other values
 * @param {string} difficulty - The difficulty value from the API
 * @returns {string} Formatted difficulty string
 */
export const formatDifficulty = (difficulty) => {
  if (!difficulty) return 'N/A';
  const normalized = difficulty.toLowerCase();
  if (normalized === 'difficult') return 'Hard';
  return difficulty.charAt(0).toUpperCase() + difficulty.slice(1).toLowerCase();
};

/**
 * Get CSS class name for difficulty badge
 * @param {string} difficulty - The difficulty value
 * @returns {string} CSS class name
 */
export const getDifficultyClass = (difficulty) => {
  const normalized = difficulty?.toLowerCase();
  switch(normalized) {
    case 'easy': return 'badge-difficulty-easy';
    case 'medium': return 'badge-difficulty-medium';
    case 'hard':
    case 'difficult': return 'badge-difficulty-hard';
    default: return 'badge-difficulty-default';
  }
};
